module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel2-fr-bfc026e90a4d26d8e7410a4722f09483.png";